import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Demo' })({
    image: {
        borderRadius: 1000,
        width: 80,
        height: 80,
        marginBottom: 8,
        objectFit: 'contain',
        background: 'linear-gradient(249deg, #FF8B61 7.18%, #D92E7F 172.88%)'
    },
    link: {
        display: 'block',
        textDecoration: 'none',
        color: '#fff',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.32px',
        transition: 'opacity 0.2s',
        opacity: 1,
        '&:visited': {
            color: '#fff'
        },
        '&:hover': {
            opacity: 0.8
        }
    }
});
